import React from "react";
import ProgressHeader from "./ProgressHeader";
import { ScreenerView } from "../../model/careScreenerModels";

const steps = [
  { viewNames: undefined, displayName: "Your family" },
  {
    viewNames: [
      ScreenerView.INSURANCE_ELIGIBILITY,
      ScreenerView.INSURANCE_CARD_UPLOAD,
      ScreenerView.VERIFICATION_PENDING,
      ScreenerView.COVERAGE_RESULT
    ],
    displayName: "Check coverage"
  },
  {
    viewNames: [
      ScreenerView.PASSWORD_INPUT,
      ScreenerView.TWO_FACTOR_AUTH,
      ScreenerView.LOADING_ACCOUNT_CREATION,
      ScreenerView.PROVIDER_SELECTION
    ],
    displayName: "Book session"
  },
  {
    viewNames: [ScreenerView.SCHEDULE_CONSULT, ScreenerView.INTAKE_CONFIRMATION, ScreenerView.ADD_INSURANCE_CARD],
    displayName: "Get started"
  }
];

export default function CareScreenerProgress({ currentView }) {
  const stepNames = steps.map(s => s.displayName);
  const currentStep = steps.find(s => s.viewNames && s.viewNames.includes(currentView));
  const currentStepIndex = currentStep ? steps.indexOf(currentStep) : -1;

  return <ProgressHeader steps={stepNames} index={currentStepIndex} />;
}
